// return the user data from the session storage

import axios from 'axios';
import { cloneElement } from "react";
import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange
} from '@mui/material/colors';
//import { setFlag } from '../components/Main/Main';
import jwt_decode from "jwt-decode";
import { usePermissionContext } from "../contexts/permission-context";
import config from '../app.config';
export const decode_token_acls = (token) => {
  let decoded = jwt_decode(token);
  let data = JSON.parse(decoded.insightUser);

  let acls = data?.userAuthInfo?.acls;
  if (acls) {
    // console.log("decode_token_acls");
  } else {
    console.log("No acls defined in auth token");
  }

  return acls;
};


export const getUser = () => {
  const userStr = sessionStorage.getItem('userId');
  if (userStr) return (userStr);
  else {
    console.log('no user session data found locally');
    return null;
  }
}

export const getEnv = () => {
  return sessionStorage.getItem('env') || null;
}
export const getCompanyId = (useCompanyId = true) => {
  if (useCompanyId) {
    const companyId = sessionStorage.getItem('companyId');
    if (companyId) return parseInt(companyId);
    else {
      console.log('no company ID found in session data found locally');
      return null;
    }
  } else {
    return 0;
  }
}
// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem('auth_token') || false;
}

// remove the token and user from the session storage
export const removeUserSession = async () => {
  try {
    const response = await axios({ method: "post", url: '/api/user/logout', headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() } })
    // console.log('logout api response:', response);
    console.log('successfull logout');
    clearUserSession();
    //setFlag(true);
    return true;
  } catch (error) {
    console.log('error in lgout:', error);
    clearUserSession();
    //setFlag(false);
    return false;
  }
}

export const clearUserSession = () => {
  // sessionStorage.removeItem('auth_token');
  // sessionStorage.removeItem('userId');
  // sessionStorage.removeItem('companyId');
  // sessionStorage.removeItem('sessionid');
  // sessionStorage.removeItem('env');
  window.localStorage.clear();
  window.sessionStorage.clear();
  console.log('cleared data from local/session storage...');
}

/*
save also userid + company id 
set the token and user from the session storage*/
export const setUserSession = (token, userId, companyId, env) => {
  if (!token.startsWith("Bearer"))
    token = "Bearer " + token;
  // let decoded = jwt_decode(token);
  // let data = JSON.parse(decoded.insightUser);
  // //replace session storage
  // sessionStorage.setItem('acls', JSON.stringify(data.userAuthInfo.acls));
  sessionStorage.setItem('auth_token', token);
  sessionStorage.setItem('userId', userId);
  sessionStorage.setItem('companyId', companyId);
  sessionStorage.setItem('env', env);
  sessionStorage.setItem('sessionExpiry', config.config.sessionInterval);
  console.log('stored data locally in session storage...');
}

export const fetchAPIData = async (apiURL, qparams) => {
  //console.log('fetching the api data now..');
  return new Promise((resolve, reject) => {
    // console.log(`calling api: ${apiURL} ...`, apiURL);

    axios({
      method: "get", url: apiURL + qparams,
      headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    })
      .then(response => {

        // console.log('api data :', response);
        var data = [];
        if (response.data.data) {
          // append id to each object for data table. each row needs unique id
          data = response.data.data.map((object, index) => {
            return { ...object, id: index + 1 };
          });
        } else {
          // append id to each object for data table. each row needs unique id
          if (Array.isArray(response.data)) {
            data = response.data.map((object, index) => {
              return { ...object, id: index + 1 };
            });
          } else {
            response.data['id'] = 1
            data = [response.data]
          }
        }
        resolve(data);
      }).catch(error => {
        console.log('error in api call:', error);
        reject(error);
      });

  });
}

export const isValidDate = (dateString) => {

  // First check for the pattern
  if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dateString))
    return false;

  // Parse the date parts to integers
  var day = parseInt(dateString.substring(8, 10), 10);
  var month = parseInt(dateString.substring(5, 7), 10);
  var year = parseInt(dateString.substring(0, 4), 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12)
    return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29;

  // Check the range of the day
  return (day > 0 && day <= monthLength[month - 1]);
}

export const compareNameIgnoreCase = (a, b) => {
  let a1 = a.name ? a.name.toLowerCase() : "", b1 = b.name ? b.name.toLowerCase() : "";
  if (a1 === b1) return 0;
  return a1 > b1 ? 1 : -1;
};

export const copyToClipboard = (event, value) => {
  navigator.clipboard.writeText(value);
};

// remove unwanted keys from object - empty, null, undefined
export const cleanObject = (object) => {
  Object.entries(object).forEach(([k, v]) => {
    if (v && typeof v === 'object')
      cleanObject(v);
    if ((v &&
      typeof v === 'object') &&
      (!Object.keys(v).length ||
        v === null ||
        v === undefined ||
        v.length === 0
      )) {
      if (Array.isArray(object))
        object.splice(k, 1);
      else if (!(v instanceof Date))
        delete object[k];
    }
  });
  return object;
};

// generates a object of hidden columns based on hide property defined in column definition
export const generateHiddenColumns = (columnDef) => {
  let hiddenColumns = {};
  columnDef.forEach(obj => {
    if (obj.hide !== undefined && obj.hide === true) {
      hiddenColumns[obj.field] = false;
      delete obj.hide;  // remove property? 
    }
  });

  return hiddenColumns;
};

export const HIDDEN_SECRET = '***';

export const hideSecret = (password) => {
  // if password is empty, null, undefined, then set to empty string. Otherwise set to hidden mask value
  return (!password?.trim().length) ? "" : HIDDEN_SECRET;
};

export const getUserAvatar = () => {
  const userStr = sessionStorage.getItem('userId');
  if (userStr) return (userStr.charAt(0).toLocaleUpperCase());
  else {
    console.log('no user session data found locally');
    return null;
  }
}


export const getRandomColor = () => {
  /* MUI color palette and shade of 500 is used for generating random colors 
     Usage:  sx={{ bgcolor: getRandomColor }}
  */

  const arr = [
    red,
    pink,
    purple,
    deepPurple,
    indigo,
    blue,
    lightBlue,
    cyan,
    teal,
    green,
    lightGreen,
    lime,
    yellow,
    amber,
    orange,
    deepOrange
  ];
  const arrLength = arr.length;
  return arr[Math.floor(Math.random() * arrLength)][500];
};


export const hasPermission = (acls, permission) => {
  //replace session storage
  // const permissions = JSON.parse(sessionStorage.getItem("acls"));

  if (!Object.keys(acls).length) {
    //console.log("hasPermission: acls was empty");
    let token = getToken();
    acls = decode_token_acls(token);
    //setPermissions(acls);
  }
  const permissions = acls;
  // console.log("hasPermission: ", permissions);
  let hasPermission = false;

  if (permissions && permissions.length && permission && permission.length) {

    // Loop for acls
    for (let i = 0; i < permissions.length; i++) {

      // Loop for incoming permission
      for (let j = 0; j < permission.length; j++) {

        if (permissions[i].permission === permission[j]) {
          hasPermission = true;
        }
      }
    }
  }

  return hasPermission;
}

export const PermissionsCheck = ({
  children,
  RenderError = () => <></>,
  errorProps = null,
  scopes = []
}) => {
  const { permissions } = usePermissionContext();
  const permissionGranted = hasPermission(permissions, scopes);

  if (!permissionGranted && !errorProps) return <RenderError />;

  if (!permissionGranted && errorProps)
    return cloneElement(children, { ...errorProps });

  return <>{children}</>;
}

export const assetsPermissionOptions = ['assets.view', 'assets.use', 'assets.manage'];
export const usersPermissionOptions = ['users.view', 'users.use', 'users.manage'];
export const platformPermissionOptions = ['platform.view', 'platform.use', 'platform.manage'];
export const companyPermissionOptions = ['company.view', 'company.use', 'company.manage'];
export const allPermissionOptions = [...assetsPermissionOptions,
...usersPermissionOptions,
...platformPermissionOptions,
...companyPermissionOptions];
export const companyManage = ['company.manage'];
export const assetsManage = ['assets.manage'];
export const assetsUse = ['assets.use'];
export const platformManage = ['platform.manage'];
export const usersManage = ['users.manage'];
export const platformUse = ['platform.use'];
export const platformUseManageOptions = ['platform.use', 'platform.manage'];
export const assetsUseManageOptions = ['assets.use', 'assets.manage'];

export const createFilterOptions = (filterOptions) => {
  let generatedFilterOptions = filterOptions;
  if (getCompanyId() === 0) {
    // add company id
    generatedFilterOptions.push('companyId');
  }

  return generatedFilterOptions;
};

export const createSortFieldOptions = (sortFieldOptions) => {
  let generatedSortFieldOptions = sortFieldOptions;
  if (getCompanyId() === 0) {
    // add company id object
    generatedSortFieldOptions .push(
      {
      field: 'companyId',
      label: 'Company ID'
      },
    );
  }

  return generatedSortFieldOptions ;
};
